import { apiRequestBase } from "./client";
import { env } from "../config/env";

interface CouponPayloadItem {
  id: number;
  amount: number;
  brandId: number | null;
  categoryIds: number[];
  manufacturId: number | null;
}

export interface CouponPayload {
  items: CouponPayloadItem[];
  code: string;
  subTotal: number;
  grandTotal: number;
  customerId: number | null;
}

export interface BogoTier {
  level: number;
  buyQty: number;
  getQty: number;
}

export interface BogoRewardItem {
  id: number;
  name: string;
  unitId: number;
  salePrice: number;
  qty: number | null;
  promoPriceTypeId: 1 | 2 | 3;
  fixedPrice: number | null;
  discountPercentage: number | null;
}

export interface BogoPromotion {
  triggerItemId: number;
  promoId: number;
  promoCode: string;
  promoName: string;
  bogoTypeId: number;
  promoAccountId: number | null;
  isRecursive: boolean;
  minQuantity: number;
  maxRewardsPerOrder: null | number;
  stockBehaviour: number;
  tiers: null | BogoTier[];
  rewardItems: BogoRewardItem[];
}

export interface FetchApplicablePromosPayload {
  itemIds: number[];
  customerId?: number;
  date: string;
  isWalkinCustomer?: boolean;
  isFromPOS?: boolean;
  warehouseId?: number;
}

export const promotionApi = {
  applyCoupon: (payload: CouponPayload) =>
    apiRequestBase<any>(env.discountBaseUrl, `/Promotions/Apply`, {
      method: "POST",
      body: payload,
    }),

  fetchApplicablePromotions: (payload: FetchApplicablePromosPayload) =>
    apiRequestBase<any>(
      env.discountBaseUrl,
      `/BogoPromotion/FetchApplicablePromotions`,
      { method: "POST", body: payload },
    ),
};
